import { atom, selector } from 'recoil';
import {
  GetFacilitiesDtoRx,
  GetFacilityDtoRx,
  GetUpdateFacilityStepDto,
  EventDtoRx,
  FacilityDeviceDtoRx,
  DeviceDtoRx,
} from '@/sdk/data-contracts';

export const facilitiesListRecoil = atom<GetFacilitiesDtoRx[]>({
  key: 'facilitiesListRecoil',
  default: [],
});

export const facilitiesDetailRecoil = atom<GetFacilityDtoRx | null>({
  key: 'facilitiesDetailRecoil',
  default: null,
});

export const facilitiesModifyRecoil = atom<GetUpdateFacilityStepDto | null>({
  key: 'facilitiesModifyRecoil',
  default: null,
});

export const facilitiesInstallationDeviceListRecoil = atom<DeviceDtoRx[]>({
  key: 'facilitiesInstallationDeviceListRecoil',
  default: [],
});

export const facilitiesEventListRecoil = atom<EventDtoRx[]>({
  key: 'facilitiesEventListRecoil',
  default: [],
});

export const facilitiesLocationInforListRecoil = atom<FacilityDeviceDtoRx[]>({
  key: 'facilitiesLocationInforListRecoil',
  default: [],
});
